<template>
    <div class="navbar-box" :class='{isShow:isShowbloon}'>
        <!-- logo -->
        <div class="logo-box">
            <div class="logo" :class='{isLogoChange:isLogoChange}' @click='tohome'></div>
            <div class="logotext-box">
                <div class="text" :class='{ishiddentext:ishiddentext}'></div>
            </div>
        </div>
        <!-- 导航 -->
        <ul class="navList" :class="{hiddenNav:menuclose}">
            <li class="nav-li-box" v-for="(item,index) in navData" :key='item.childName'><a :href="item.path"
                    class="navlink">
                    <span>{{item.name}}</span>
                    <span>{{item.childName}}</span>
                </a>
            </li>
        </ul>
        <!-- 子导航&手机导航 -->
        <div class="mobileNav" :class='{roudeblack:isLogoChange}'>
            <div class="menu" :class='{isClose:close,mobileNavchange:isLogoChange}' @click='menuChange'></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NavBar',
        data() {
            return {
                close: false,//是否显示关闭动画
                menuclose: false,//导航是否显示
                isLogoChange: false,//logo图案是否改变
                ishiddentext: false,//公司名称是否隐藏
                isShowbloon: false,//显示导航

                middlelogochange: '',//切换的中间变量
                middlemenuclos: '',//导航是否显示的中间变量
                navData: [
                    {
                        name: '首页',
                        childName: 'Home',
                        path: '/'
                    },
                    {
                        name: '解决方案',
                        childName: 'Program',
                        path: '/program'
                    },
                    {
                        name: '精彩案例',
                        childName: 'Case',
                        path: '/case'
                    },
                    {
                        name: '关于我们',
                        childName: 'About',
                        path: '/about'
                    },
                    {
                        name: '蓝鲸营销学院',
                        childName: 'School',
                        path: '/school'
                    },
                    {
                        name: '常见问题',
                        childName: 'FAQ',
                        path: '/faq'
                    },
                    {
                        name: '联系我们',
                        childName: 'Contact',
                        path: '/contact'
                    },
                ]
            }
        },
        methods: {
            menuChange() {
                let _this = this
                setTimeout(() => {
                    //保存logo和菜单切换前的颜色
                    if (_this.middlelogochange === '') {
                        _this.middlelogochange = _this.isLogoChange
                        _this.isLogoChange = false
                    } else {
                        _this.isLogoChange = _this.middlelogochange
                        _this.middlelogochange = ''
                    }
                    //改变菜单的切换状态
                    _this.close = !_this.close
                    //保存pc导航栏切换前的状态
                    if (_this.middlemenuclos === '') {
                        _this.middlemenuclos = _this.menuclose
                        _this.menuclose = true
                    } else {
                        _this.menuclose = _this.middlemenuclos
                        _this.middlemenuclos = ''
                    }
                    // _this.menuclose = _this.close
                }, 300)
                this.$parent.changeChildMobileNav()
            },
            changeLogo(blooen) {//改变logo颜色
                this.isLogoChange = blooen
            },
            changelogotext(blooen) {//是否隐藏公司名称
                this.ishiddentext = blooen
            },
            hiddenNavList(blooen) {
                this.menuclose = blooen
            },
            changeNavbar() {
                this.isShowbloon = true
            },
            //=======================================================点击logo到首页==============================================================
            //1.点击logo判断页面路由 this.$router.path
            //2.如果是首页则返回顶部，如果是其它页面则跳转到首页
            tohome(){
                const url=this.$route.path
                url==='/'? this.totop():window.location.href = '/'
            },
            totop(){
                document.body.scrollIntoView({block: 'start',behavior: "smooth"})||document.documentElement.scrollIntoView({block: 'start',behavior: "smooth"})
            }
        }
    }
</script>
<style scoped>
    @import url(../../font/ifont/iconfont.css);

    .navbar-box {
        padding: 1.6% 2%;
        width: 100%;
        height: 130Px;
        position: fixed;
        top: -100%;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-content: center;
        z-index: 80;
        transition: all 0.75s ease-in-out;
    }

    .isShow {
        top: 0;
    }

    .logo-box {
        justify-self: center;
        align-self: center;
        height: 68px;
        display: flex;
        /* background: url('../../assets/LOGO.png') no-repeat center;
        background-size: cover; */
    }

    .logo {
        width: 68px;
        height: 100%;
        background: url('../../assets/bluelogo.png') no-repeat center;
        background-size: cover;
        cursor: pointer;
    }

    .isLogoChange {
        background: url('../../assets/colorlogo.png') no-repeat center;
        background-size: cover;
    }

    .logotext-box {
        width: 192px;
        height: 100%;
        overflow: hidden;
    }

    .text {
        width: 100%;
        height: 100%;
        background: url('../../assets/LOGOtext.png') no-repeat center;
        background-size: cover;
        transition: all 0.5s;
    }

    .ishiddentext {
        transform: translateX(-100%);
    }

    .mobileNav>i {
        color: #ffffff;
        font-size: 25px;
    }

    .navList {
        display: flex;
        width: 60%;
        align-items: center;
        justify-content: space-between;
        /* transform: translateX(-16%); */
        opacity: 1;
        transition: all 0.3s;
    }

    .nav-li-box {
        height: 100%;
    }

    .nav-li-box:not(:last-child) {
        /* margin-right: 89px; */
    }

    .navlink {
        display: inline-block;
        width: 100%;
        height: 100%;
        overflow-y: hidden;
    }

    .navlink>span {
        color: #ffffff;
        font-size: 16Px;
        display: block;
        height: 100%;
        transition: all 0.5s;
    }

    .navlink>span::before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        height: 100%;
    }

    .nav-li-box:hover .navlink>span {
        transform: translateY(-100%);
    }

    .mobileNav {
        justify-self: center;
        align-self: center;
        width: 68Px;
        height: 68Px;
        text-align: center;
        cursor: pointer;
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0);
        transition: all 0.5s;
    }

    .mobileNav::after {
        content: '';
        display: block;
        position: absolute;
        border: 1px solid rgba(255, 255, 255, 0);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        width: 60%;
        height: 60%;
        transform: translate(-50%, -50%);
        z-index: -1;
        transition: all 0.5s;
    }

    .mobileNav:hover::after {
        width: 80%;
        height: 80%;
        border: 1px solid rgba(255, 255, 255, 1);
    }

    .roudeblack:hover::after {
        border: 1px solid rgba(0, 0, 0, 1);
    }

    /* .box {
        margin: 200px;
    } */

    .menu {
        width: 25Px;
        height: 25Px;
        position: relative;
    }

    .menu:before,
    .menu:after {
        content: "";
        display: block;
        height: 2px;
        background: #ffffff;
        border-radius: 8Px;
        position: absolute;
        left: 0;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
    }

    .mobileNavchange::before,
    .mobileNavchange::after {
        background: #000000;
    }

    .menu:before {
        width: 25Px;
        top: 3Px;
        /* box-shadow: 0 12px #ffffff; */
    }

    .menu:after {
        width: 20Px;
        box-shadow: 0 8Px #ffffff;
        bottom: 12Px;
    }

    .mobileNavchange::after {
        width: 20Px;
        box-shadow: 0 8Px #000000;
        bottom: 12Px;
    }

    .isClose::after {
        width: 25Px;
        box-shadow: none;
        bottom: 11Px;
        transform: rotate(225deg);
    }

    .isClose::before {
        top: 11Px;
        transform: rotate(140deg);
    }

    .hiddenNav {
        opacity: 0;
        transform: translateY(-200%);
    }

    /* .menu:hover::after {
        width: 25px;
        box-shadow: none;
        bottom: 11px;
        transform: rotate(225deg);
    }
    .menu:hover:before {
        top: 11px;
        transform: rotate(140deg);
    } */
    @media(max-width: 1260px){
        .navbar-box {
        padding:0 2%;
        height: 100PX;
        padding-top: 0;
    }
    }
    @media(max-width: 992px){
        .logotext-box,.navList{
            display: none;
        }
    }
    /* @media(max-width:1023px) {
        .navbar-box {
        height: 80PX;
    }
        .navList {
            display: none;
        }

        .logo-box {
            height: 150px;
        }

        .logo {
            width: 150px;
        }

        .logotext-box {
            width: 350px;
        }

        .mobileNav {
            width: 150px;
        }

        
        .menu {
            width: 50%;
            height: 50%;
            position: relative;
        }

        .menu:before,
        .menu:after {
            width: 100%;
        }

        .menu:after {
            box-shadow: 0 15px #ffffff;
            bottom: 50%;
        }

        .mobileNavchange::after {
            box-shadow: 0 15px #000000;
        }

        .menu:before {
            width: 60%;
            top: 20%;
        }


        .isClose::after {
            bottom: 60%;
            box-shadow: none;
            transform: rotate(235deg);
        }

        .isClose::before {
            top: 20%;
            width: 100%;
            transform: rotate(130deg);
        }

        .mobileNav:hover::after {
            border: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/base/navbar.vue